import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface AdminLocation {
  id: number;
  locId: string;
  locSapId: string | null;
  locName: string;
  region: string | null;
  market: string | null;
  status: string;
  locationType: string | null;
  locationFacilityType: string | null;
  organizationType: string | null;
  is3pl: boolean | null;
  executionSystem: string | null;
}

interface AdminLocationsState {
  /** Active locations fetched from /api/admin/locations */
  locations: AdminLocation[];
  /** Whether the API call is in progress */
  loading: boolean;
  /** Error message if the fetch failed */
  error: string | null;
  /** Timestamp of last successful fetch (used for cache validation) */
  fetchedAt: number | null;
}

const initialState: AdminLocationsState = {
  locations: [],
  loading: false,
  error: null,
  fetchedAt: null,
};

// ─── Slice ────────────────────────────────────────────────────────────────────

const adminLocationsSlice = createSlice({
  name: 'adminLocations',
  initialState,
  reducers: {
    setAdminLocationsLoading(state) {
      state.loading = true;
      state.error = null;
    },

    setAdminLocations(state, action: PayloadAction<AdminLocation[]>) {
      state.locations = action.payload;
      state.loading = false;
      state.error = null;
      state.fetchedAt = Date.now();
    },

    setAdminLocationsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    resetAdminLocations(state) {
      state.locations = [];
      state.loading = false;
      state.error = null;
      state.fetchedAt = null;
    },
  },
});

export const {
  setAdminLocationsLoading,
  setAdminLocations,
  setAdminLocationsError,
  resetAdminLocations,
} = adminLocationsSlice.actions;

export default adminLocationsSlice.reducer;
